import cn from 'clsx'

import { ImageBox, NavLink, Button } from 'shared-components'
import { returnDate } from 'shared-functions'

import s from './FeaturePost.module.sass'

function FeaturePost({ post }: any) {
    const { _createdAt, title, slug, featuredImage, excerpt, category } = post

    const _excerpt = excerpt?.length > 200 ? `${excerpt.substring(0, 200)}...` : excerpt

    return (
        <div className={s.FeaturePost}>
            <div className={cn(s.Cont, 'container')}>
                <NavLink href={`/news/${slug?.current}`} className={s.Link}>
                    <div className={s.Image}>{featuredImage && <ImageBox image={featuredImage} />}</div>
                    <div className={s.Content}>
                        <div className={s.ContentInner}>
                            <div className={cn(s.Date, 'smallCaps')}>{returnDate(_createdAt)}</div>
                            <div className={s.Title}>
                                {title && (
                                    <h2
                                        dangerouslySetInnerHTML={{
                                            __html: title,
                                        }}
                                    />
                                )}
                            </div>
                            {_excerpt && (
                                <div
                                    className={cn(s.Excerpt, 'copy small')}
                                    dangerouslySetInnerHTML={{
                                        __html: _excerpt,
                                    }}
                                />
                            )}
                            {category && (
                                <div className={s.Category}>
                                    <Button title={category?.name} small noArrow />
                                </div>
                            )}
                        </div>
                    </div>
                </NavLink>
            </div>
        </div>
    )
}

export default FeaturePost
